export default "__VITE_ASSET__DFLnEDAa__"